import { Brand } from "../types";
import { useBrandContext } from "./context";

const useBrand = (propBrand?: Brand): Brand => {
  const { brand } = useBrandContext();
  return propBrand ?? brand;
};

export default useBrand;
